import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../common/services/customer/Actions';
import * as CustomerService from '../../../common/services/customer/Service';
import { CustomerDataDTO } from '../../../common/types/dto/CustomerDataDTO';
import { VehicleDataDTO } from '../../../common/types/dto/VehicleDataDTO';
import cssMessages from '../../assets/scss/Messages.scss';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';
import css from './VehicleSelect.scss';

import Slider, { CustomArrowProps, Settings } from 'react-slick';
import NoVehicle from '../../main/components/NoVehicle';

interface VehicleSelectState {
    vehcode: number;
    vehicles: VehicleDataDTO[];
}

export interface VehicleSelectProps {
    onChange: (selected: number) => void;
    isMini: boolean;
    defaultVehcode?: number;
}

interface ReduxStateProps {
    isCommunicating: boolean;
    customerInfo: CustomerDataDTO | undefined;
}

interface ReduxDispatchProps {
    customerActions: typeof Actions;
    customerServiceActions: CustomerService.ServiceActions;
}

type VehicleSelectProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & VehicleSelectProps;

const VehicleSelectV2: React.FC<VehicleSelectProperties> = (Props) => {
    const initialState: VehicleSelectState = {
        vehcode: Props.defaultVehcode ? Number(Props.defaultVehcode) : - 1,
        vehicles: [],
    };
    const [state, setState]: [VehicleSelectState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    useEffect(() => {
        if (Props.customerInfo && Props.customerInfo.vehicles && Props.customerInfo.vehicles.length > 0) {
            setState({ vehicles: Props.customerInfo.vehicles });
            Props.onChange(state.vehcode >= 0 ? state.vehcode : Props.customerInfo.vehicles[0].vehcode);
        }
    }, [Props.customerInfo]);

    function buildVehicles(vehicles: VehicleDataDTO[]) {
        return vehicles.map((vehicleItem: VehicleDataDTO) => {
            return (
                <React.Fragment key="vehicleItem">
                    <div className={css.large} style={Props.isMini ? { display: 'none' } : {}}>
                        <div className={css.carouselWrapper}>
                            <div className={css.imageContainer} data-series={vehicleItem.series} >
                                <img className={css.vehicleImage} src={config.CosyImagesPath + vehicleItem.imgUrl} />
                            </div>

                            <div className={classNames([css.carouselInfo, 'my-bmw-servicos-value-service-banner'])}>
                                <div className={classNames(['grid-container', 'pacote-orbit-info', 'show-for-medium'])} style={{ position: 'static' }}>
                                    <div className={'pacote-orbit-info-matricula'}>
                                        <p>{t('vehicleSelect.licensePlate')}</p>
                                        <div className={'stat'}>{vehicleItem.licensePlate}</div>
                                    </div>
                                    <div className={'pacote-orbit-info-modelo'}>
                                        <p>{t('vehicleSelect.model')}</p>
                                        <div className={'stat'}>{vehicleItem.model ? vehicleItem.model : ''}</div>
                                    </div>
                                    <div className={'pacote-orbit-info-chassis'}>
                                        <p>{t('vehicleSelect.serialNumber')}</p>
                                        <div className={'stat'}>{vehicleItem.vin}</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* IS MINI is here!!!!!*/}
                    <div>
                        <div className={!Props.isMini ? css.small : null}>
                            <div className={css.imageContainerMini} data-series={vehicleItem.series}>
                                <img src={config.CosyImagesPath + vehicleItem.imgUrl} width="100%" />
                            </div>
                            <div className={'my-bmw-servicos-value-service-banner'}>
                                <div className={classNames(['grid-container', 'pacote-orbit-info'])} style={{ paddingBottom: '40px' }}>
                                    <div className={classNames(['pacote-orbit-info-modelo', 'pacote-orbit-info-modelo-mini'])}>
                                        <div className={'stat'}>{vehicleItem.model ? vehicleItem.model : ''}</div>
                                    </div>
                                    <div className={'pacote-orbit-info-matricula'}>
                                        <div className={'stat'}>{vehicleItem.licensePlate}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        });
    }

    function onChange(currentSlide: number) {
        const vehcode = state.vehicles[currentSlide].vehcode;
        Props.onChange(vehcode);
    }
    function PrevArrow(props: CustomArrowProps): JSX.Element {
        const { onClick } = props;
        return (
            <button className={classNames([Props.isMini ? css.miniArrowSlickPrev : css.arrowSlickPrev, config.BrandEnv === 'BMW' ? null : 'white-color'])} onClick={onClick} > <FontAwesomeIcon icon={faChevronLeft} /></button >
        );
    }
    class NextArrow extends React.Component<CustomArrowProps> {
        public render() {
            return <button className={classNames([Props.isMini ? css.miniArrowSlickNext : css.arrowSlickNext, config.BrandEnv === 'BMW' ? null : 'white-color'])} onClick={this.props.onClick}><FontAwesomeIcon icon={faChevronRight} /></button>;
        }
    }
    const settings: Settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: onChange,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    const vehVehicle = state.vehicles.find((x) => x.vehcode === state.vehcode);
    const indexOf = vehVehicle ? state.vehicles.indexOf(vehVehicle) : 0;
    return (
        <React.Fragment>
            <div className={'cell'}>
                {state.vehicles.length > 0 ?
                    <Slider {...settings} initialSlide={indexOf}>
                        {buildVehicles(state.vehicles)}
                    </Slider>
                    :
                    <NoVehicle />
                }
            </div>
            {Props.customerInfo && Props.customerInfo.vehiclesFromOtherBrandsDetected && <div className={cssMessages.infoMsg} >
                <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                <b>{t('profile:otherBrands1')}</b>
                <br />
                <b>{t('profile:otherBrands2')}<a target="_blank" href={config.BrandEnv === 'BMW' ? config.RedirectToMyMINI : config.RedirectToMyBMW}>{t('profile:otherBrands2Link')}</a></b>
                <br />
                <b>{t('profile:otherBrands3')}</b>
            </div>}

        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.customerState.customerData.isCommunicating,
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    customerActions: bindActionCreators(Actions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSelectV2);
